module.exports = __webpack_public_path__ + "img/lr-cb66-1.cf26173d.gif";